import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { uniqueId, isEmpty } from 'lodash/fp';

import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/Info';
import IconButton from '@material-ui/core/IconButton';

import { AlertIcon } from '../../../assets/svg/Icon';

import { styles, StyledBadge } from '../style';

const useStyles = makeStyles(styles);
const initPath = `/${process.env.REACT_APP_PATH}`;

export default function DisasterList(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    datas, currentAreaCode, handleDisasterDetailList, mobilemode,
  } = props;

  const renderList = (dataList, boxClass) => (
    <>
      {dataList !== undefined && dataList.map((row) => (
        <Grid item key={uniqueId()}>
          <Box className={`${classes.listsBox} ${boxClass}`}>{currentAreaCode > 0 ? row.amphoe_name : row.province_name}</Box>
        </Grid>
      ))}
    </>
  );

  return (
    <>
      <Box className={mobilemode ? classes.boxViewMobile : classes.boxViewCrisis}>
        <Box display="flex" justifyContent="flex-end">
          <Box>
            <Box display="flex" alignItems="center">
              <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                <IconButton
                  id="disaster_detail"
                  disabled={datas.count <= 0}
                  onClick={mobilemode ? null : handleDisasterDetailList(datas.dataListTambon)}
                >
                  <StyledBadge
                    id="main-disaster-click"
                    badgeContent={datas.count}
                    overlap="circular"
                    color="secondary"
                  >
                    <AlertIcon style={{ color: 'white' }} />
                  </StyledBadge>
                </IconButton>
              </Box>
              <Box id="dialog_disaster" display="flex" alignItems="center">
                <Box pl={1}>
                  <InfoIcon style={{ fontSize: 13, color: '#777' }} />
                </Box>
                <Box p={1}>
                  <NavLink id="navigate_disaster" to={`${initPath}risk`} activeClassName="nav-active">
                    <Typography className={classes.titleBox}>{t('พื้นที่ประกาศภัย')}</Typography>
                  </NavLink>
                </Box>
                <Box><Typography className={classes.timeBox}>{datas.time}</Typography></Box>
              </Box>
            </Box>
            <Box>
              <Grid id="dialog_disaster_list_provinces" container justifyContent="flex-start" spacing={1} className={classes.contentBox}>
                {isEmpty(datas) ? null
                  : (
                    <>
                      {(datas.count <= 0)
                        ? (
                          <Grid item>
                            <Box
                              className={`${classes.listsBox}`}
                              style={{ backgroundColor: '#FFFFFF50', fontWeight: 'bold' }}
                            >
                              {t('ปกติ')}
                            </Box>
                          </Grid>

                        ) : renderList(datas.list, classes.yellow)}
                    </>
                  )}
              </Grid>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

DisasterList.defaultProps = {
  currentAreaCode: '',
  mobilemode: false,
};

DisasterList.propTypes = {
  datas: PropTypes.instanceOf(Object).isRequired,
  currentAreaCode: PropTypes.string,
  handleDisasterDetailList: PropTypes.func.isRequired,
  mobilemode: PropTypes.bool,
};
